// extracted by mini-css-extract-plugin
module.exports = {"background":"LandingPage_background___H9b2","div":"LandingPage_div__VodhG","btn":"LandingPage_btn__1NWws","link":"LandingPage_link__3LzLh"};